export abstract class SosCoreConfig {
    abstract api_url: string;
    abstract profile_id: string;
    abstract key: string
    abstract obf_loaded?: boolean;
    abstract payload?: string;
}